export function GET_DASHBOARD(body = {}) {
    return {
        type: "GET_DASHBOARD",
        body
    };
};


// WEBPACK FOOTER //
// ./src/store/actions/dashboard.js